import Vue from 'vue'
import router from './router/login.js'
import login from './login.vue'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/scss/index.scss'
import http from './api/http'
import 'babel-polyfill'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(http)

/* eslint-disable no-new */
setTimeout(function () {
  const app = new Vue({
    el: '#app',
    router,
    template: '<login/>',
    components: { login }
  })
  if (window.isDemo) {
    window.getAppInstance = function () {
      return app
    }
  }
}, 0)



// WEBPACK FOOTER //
// ./src/login.js